<div>
    @if (!normalMode) {
        <div class="bar1">
            <button mat-button (click)="exitDialogMode()">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="video-caption">{{'general.videoTutorial' | transloco}}</div>
            <button mat-button (click)="exitDialogMode()" style="margin-right: 0;">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    }
<mat-drawer-container style="height: 100%">
    <mat-drawer opened [mode]="sidenavMode" #sidenav [disableClose]="sidenavMode === 'side'">
        <div fxLayout="column" [ngClass]="{'navList': normalMode, 'navList-dialog': !normalMode}" style="width: 325px; height: 100%">
            <div style="display: flex; width: 100%; height: 40px; margin-bottom: 20px">
                <mat-tab-group #tabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="mini-tab" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
                    <mat-tab label="Lessons"></mat-tab>
                    <mat-tab label="All"></mat-tab>
                </mat-tab-group>
                <mat-icon (click)="onMinimized()" style="cursor: pointer; position: absolute; right: 10px; top: 10px">
                    keyboard_double_arrow_left
                </mat-icon>
            </div>
            @if (!lessonMode) {
                <div class="input-group" style="display: flex;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>{{ 'placeholder.search' | transloco }}</mat-label>
                        <input matInput type="text"
                               (keyup)="searchTutorial()"
                               name="SearchDualList"
                               class="form-control"
                               [(ngModel)]="filter"
                               autocomplete="off"/>
                        <a matSuffix aria-label="Clear" (click)="filter=''">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                </div>
            }
            <mat-tree class="customBackgroundColor" [dataSource]="dataSource" [treeControl]="treeControl" [ngClass]="{'d-none': (filter.length > 1 || lessonMode)}">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <li class="childSelection" [ngClass]="{'active': activeVideoId == node.videoid}">
                        <div>
                            <!--<mat-icon (click)="clickedLeaf(node)" class="loadVideo parent">{{ activeVideoId == node.videoid ? 'pause_circle_outline' : 'play_circle_outline' }}</mat-icon>-->
                            <app-progress-arc class="progress" [progress]="getProgress(node.videoid)" (click)="clickedLeaf(node)"></app-progress-arc>
                            <span class="loadVideo" (dblclick)="openModal(node)"
                                  (click)="clickedLeaf(node)">{{ node.name }}</span>
                        </div>
                    </li>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <li>
                        <div class="mat-tree-node">
                            <button mat-icon-button matTreeNodeToggle class="mini-button">
                                <fa-icon [icon]="treeControl.isExpanded(node) ? faFolderOpen : faFolder"></fa-icon>
                            </button>
                            <span matTreeNodeToggle>{{ node.name }}</span>
                        </div>
                        <ul [hidden]="!treeControl.isExpanded(node)">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </ul>
                    </li>
                </mat-nested-tree-node>
            </mat-tree>
            @if (filter.length > 1 || lessonMode) {
                <div>
                    <ul>
                        @for (node of searchVideos; track node) {
                            <li>
                                <div class="childSelection" [ngClass]="{'active': activeVideoId == node.videoid}" style="margin-bottom: 10px; padding-bottom: 10px;">
                                    <app-progress-arc class="progress" [progress]="getProgress(node.videoid)" (click)="clickedLeaf(node)"></app-progress-arc>
                                    <span class="loadVideo" (dblclick)="openModal(node)"
                                          (click)="clickedLeaf(node)">{{ node.name }}</span>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            }
            <!-- <app-loading [@inOutAnimation] *ngIf="!ready" [size]="'50px'" [style]="{'margin-top': '150px'}"></app-loading>-->
        </div>
    </mat-drawer>
    <mat-drawer-content style="height: 100%">
        <div class="content customBackgroundColor2" [ngClass]="{'navList': normalMode, 'navList-dialog': !normalMode}">
            <div class="hide-gt-xs">
                <button (click)="toggleVideoPane()" mat-button class="pull-right" (click)="sidenav.toggle();">
                    @if (toggleIcon) {
                        <mat-icon>keyboard_double_arrow_left</mat-icon>
                    }
                    @if (!toggleIcon) {
                        <mat-icon>keyboard_double_arrow_right</mat-icon>
                    }
                </button>
            </div>
            @if (!sidenav.opened) {
                <button (click)="onMaximized()" mat-button class="pull-left" style="padding-top: 10px">
                    <mat-icon>keyboard_double_arrow_right</mat-icon>
                </button>
            }

            @if (!videoSource) {
                VV
                <div style="width: 100%; height: 100%" fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon class="buttPlayLrg">play_circle_outline</mat-icon>
                    <h1 class="big-message hide-lt-lg">{{ 'general.noVideoSelected' | transloco }}</h1>
                    <h2 class="hide-gt-md" style="font-size: 1.4em">{{ 'general.noVideoSelected' | transloco }}</h2>
                </div>
            }
            @if (videoSource) {
                    <!-- <mat-video [overlay]="true" src="{{videoSource}}" [autoplay]="true"></mat-video>-->
                    @if (showManual) {
                        <div class="startNow">
                            <button color="warn" (click)="playClick()" mat-raised-button [ngStyle]="{transform: 'scale(2.6)'}">
                                <mat-icon>play_circle_outline</mat-icon>
                            </button>
                        </div>
                    }


                    <vg-player class="video-player" (onPlayerReady)="onPlayerReady($event)">
                            <div class="aspect-ratio-container">
                            @if (showTips) {
                                <div class="tips fade-in shake">
                                    <!--                        <button mat-flat-button (click)="onCloseTip()" class="pull-right">-->
                                    <!--                            <mat-icon>close</mat-icon>-->
                                    <!--                        </button>-->
                                    @for (tip of tips; track tip) {
                                        <div>
                                            <br/>
                                            <mat-label class="tipName">{{ tip.name }}</mat-label>
                                            <br/>
                                            <br/>
                                            @if (tip.link.length > 0) {
                                                <mat-label class="tipLink" (click)="onOpenLink(tip.link)">{{ tip.link }}</mat-label>
                                            }
                                            <br/>
                                            <br/>
                                            <mat-divider></mat-divider>
                                            <br/>
                                        </div>
                                    }
                                </div>
                            }
                            <!-- disable Chrome cast add controlsList="nodownload"  -->
                            <!--                    <video controls controlsList="nodownload" id="singleVideo" [vgMedia]="$any(media)" #media [autoplay]="true" crossorigin>-->
                            <video class="video-element" #videoElement controls id="singleVideo" [vgMedia]="$any(media)" #media crossorigin
                                (ended)="onVideoEnded()"
                                (loadedmetadata)="onVideoCreated()"
                                (canplay)="onVideoCanPlay()"
                                (play)="onVideoPlay()"
                                (pause)="onVideoPause()"
                                (seeked)="onVideoSeek()"
                                (timeupdate)="onVideoTimeUpdate(videoElement.currentTime)">
                                <source src="{{videoSource}}" type="video/mp4">
                                <track
                                    style="color: red"
                                    src="{{vttSource}}"
                                    kind="subtitles"
                                    srclang="en"
                                    label="English"
                                    default
                                    (load)="onVttCanPlay()"
                                    (cuechange)="onSubtitle($event)"
                                  />
                            </video>

                            <audio #audioPlayer (canplaythrough)="onAudioCanPlay()" preload="auto">
                                <source src="{{audioSource}}" type="audio/mpeg" />
                            </audio>

                            @if (lessonMode && isVideoEnded) {
                                <div class="next-container">
                                    <button mat-raised-button class="play-next" (animationend)="onPlayNext()" (click)="onPlayNext()">play next video</button>
                                    <button mat-raised-button (click)="onCancel()">cancel</button>
                                </div>
                            }

                            <div class="subtitle-container">
                                @if (currentSubtitle!='') {
                                    <div class="subtitle-container">{{ currentSubtitle }}</div>
                                }
                            </div>


                        <vg-controls class="video-controls">
                            <vg-play-pause></vg-play-pause>
                            <vg-playback-button></vg-playback-button>
                            <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                            <vg-scrub-bar>
                                <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                                <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                            </vg-scrub-bar>
                            <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                            <vg-mute></vg-mute>
                            <vg-volume></vg-volume>
                            <vg-fullscreen></vg-fullscreen>
                        </vg-controls>
                    </div>
                </vg-player>

            }
        </div>
    </mat-drawer-content>
</mat-drawer-container>
</div>


<ng-template let-modal #copyUrlModal>
    <div mat-dialog-content>
        <div class="helper-image">
            <button mat-flat-button (click)="onOpenLink()">
                <mat-icon>language</mat-icon>
            </button>
            <button (click)="copyText()" mat-flat-button [cdkCopyToClipboard]="this.videoUrl">
                <mat-icon>content_copy</mat-icon>
            </button>
            <mat-label>
                {{ videoUrl }}
            </mat-label>
        </div>
    </div>
</ng-template>


